var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0005 89.52V38.4L58.4005 63.9199M9.36047 48.56C8.53995 47.6851 8.07667 46.5348 8.06187 45.3355C8.04706 44.1362 8.4818 42.9748 9.28047 42.08L16.0005 35.84C17.1205 34.8 19.8405 34.4 21.8405 35.84L40.9605 50.4799L85.3605 9.75995C87.1205 7.99995 90.2405 7.19995 93.7605 9.11995L116.16 19.84C118.16 21.04 120.08 22.88 120.08 26.32V102.24C120.08 104.48 118.48 106.88 116.72 107.84L92.0805 119.68C90.3205 120.4 86.9605 119.68 85.7605 118.56L40.8805 77.52L21.8405 92.16C19.6805 93.6 17.0405 93.2 15.9205 92.16L9.20047 86C7.44047 84.16 7.60047 81.12 9.52047 79.28L26.3205 64.08",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.f53b74c87eab2be767110f613d4d83d4.svg";
export { ForwardRef as ReactComponent };